import type { DeviceShadowApiSchema } from "@screencloud/native-players-helpers";

import type { RdmCommandType } from "./useRdmCommand";

export function hasRdmCommands(
  apiSchema: DeviceShadowApiSchema | null | undefined,
  ...commands: RdmCommandType[]
): boolean {
  if (!apiSchema || typeof apiSchema !== "object" || Array.isArray(apiSchema)) {
    return false;
  }
  return commands.every((command) => command in apiSchema);
}
